import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import { getAccessToken, useAuthStore } from '@/features/auth/store'
import { initializeAnalytics } from '@/lib/analytics'
import { registerAuthTokenProvider } from '@/lib/api/auth-token'
import { createQueryClient } from '@/lib/query-client'

import { createAppRouter } from './router'
import { RouteSpinner } from '@/components/ui/RouteSpinner'
import './styles.css'

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

const unsubscribeAnalytics = initializeAnalytics(router)
if (import.meta.hot) import.meta.hot.dispose(unsubscribeAnalytics)

// Lets the API client read the token, and clears the session on any 401.
registerAuthTokenProvider(getAccessToken, () => {
  useAuthStore.getState().clearSession()
  void router.navigate({ to: '/login', replace: true })
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found.')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<RouteSpinner />}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
)
